import styled from 'styled-components';

export default styled.div`
  .title-three-tip-icon {
    width: 14px;
    height: 14px;
    color: #9e9e9e;
  }
  .multiple-wrap-style {
    margin: 0;
    margin-top: -3px;
    #demo-multiple-chip {
      max-height: 190px;
      overflow: auto;
    }
  }
`;
